import * as React from 'react';

interface Iprops {
  messages: any;
}


class Test extends React.Component<Iprops> {
  public render() {
    const { messages } = this.props;

    return (
      <div className="App">
        <p className="App-intro">
          {messages.test}
        </p>
      </div>
    );
  }
}

export default Test;



// WEBPACK FOOTER //
// ./src/pages/test.tsx